import axios from "axios";
import { getBaseUrl } from "./api"; 

export const api = axios.create({
  baseURL: getBaseUrl(), 
  headers: {
    "Content-Type": "application/json",
  },
});